export const resolutionToCandleType: Record<string, string> = {
  '1': '1min',
  '5': '5min',
  '15': '15min',
  '30': '30min',
  '60': '1hour',
  '120': '2hour',
  '240': '4hour',

  D: 'Day',
  '1D': 'Day',

  W: 'Week',
  '1W': 'Week',

  M: 'Month',
  '1M': 'Month',
}
